import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadio = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 7,
		fill: "#006ADC"
	}), /* @__PURE__ */ _jsx("rect", {
		x: .75,
		y: .75,
		width: 22.5,
		height: 22.5,
		rx: 11.25,
		stroke: "#D9DEEB",
		strokeWidth: 1.5
	})]
});
const ForwardRef = forwardRef(SvgRadio);
export default ForwardRef;
